import useTranslator from "../../hooks/useTranslator";
import UserIcon from "../../assets/img/user-icon.svg";
import { useContext, useEffect, useState } from "react";
import LandLordContext from "../../context/landlord/LandLordContext";
import { isDefaultWorkspace, toast, isOwnerOfWorkspace } from "../../helper/common";
import { getInstitutionalDomainName, haveValue } from "../../helper/common";
import Loader from "../Loader";
import ConfirmMemberRemovalModal from "./ConfirmMemberRemovalModal";
import AuthContext from "../../context/auth/AuthContext";
import { WORKSPACE_ROLES_CAPABILITIES } from "../../Utils/workspaceRoleCapabilities";
import ButtonActionTooltip from "../ErrorModal/ButtonActionTooltip";

const ManageMembers = (props) => {
  const { _t } = useTranslator();
  const allRoles = WORKSPACE_ROLES_CAPABILITIES?.roleHierarchyBasedOnIndex;
  const { manageMembers, isInputDropdown, setIsInputDropdown } = props;
  const { getWorkspaceMembers, inviteWorkspaceMembers, updateWorkspaceRoles } =
    useContext(LandLordContext);
  const { user } = useContext(AuthContext);
  const [workspaceMembers, setWorkspaceMembers] = useState([]);
  const [inviteEmail, setInviteEmail] = useState("");
  const [localLoader, setLocalLoader] = useState(false);
  const [showRemoveModal, setRemoveModal] = useState(false);
  const [removalLandlord, setRemovalLandlord] = useState(null);
  const [isOpenIndex, setIsOpenIndex] = useState(-1);
  const [inviteRole, setInviteRole] = useState("BRONZE");

  const [isSendingInvite, setIsSendingInvite] = useState(false);

  useEffect(() => {
    defaultFunc();
  }, [manageMembers]);

  const defaultFunc = () => {
    setLocalLoader(true);

    getWorkspaceMembers()
      .then((res) => {
        setWorkspaceMembers(res?.success_res?.workspaceMembers);
      })
      .catch((err) => {
        console.log(err);
        toast.error(_t("errorWhileFetchingWorkspaceMembers"));
      })
      .finally(() => {
        setLocalLoader(false);
      });
  };

  const handleSendInvite = () => {
    if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(inviteEmail)) {
      setIsSendingInvite(true);
      inviteWorkspaceMembers({ email: inviteEmail, role: inviteRole })
        .then((res) => {
          setInviteEmail("");
          defaultFunc();
        })
        .catch((err) => {
          if(haveValue(err?.response?.data?.message?.key)) {
            toast.error(_t(err?.response?.data?.message?.key));
          } else {
            toast.error(_t("errorWhileSendingInvite"));
          }
        }).finally(() => {
          setIsSendingInvite(false);
        });
    } else {
      toast.error(_t("invalidEmailAddress"));
    }
  };

  const changeMemberRole = (e, memberVal, index) => {
    const newRole = e.target.value;
    const sendData = {
      user_id: memberVal?._id,
      new_role: newRole,
    };

    setWorkspaceMembers((prev) =>
      prev.map((m, i) => (i === index ? { ...m, role: newRole } : m))
    );

    updateWorkspaceRoles(sendData)
      .then((res) => {})
      .catch((err) => {
        console.log(err);
        defaultFunc();
        toast.error(_t("errorWhileUpdatingMemberRole"));
      });
  };

  const handleCloseRemovalModal = () => {
    setRemoveModal(false);
  };

  const handleRemoveMember = (val) => {
    setRemovalLandlord(val);
    setRemoveModal(true);
  };

  const changeInviteRole = (val) => {
    setInviteRole(val);
  };

  const CheckmarkIcon = ({ val }) => (
    <img
      src="/images/checkmark-green.svg"
      alt="Close"
      className="cancelIcon cursor-pointer"
      onClick={(e) => handleRemoveMember(val)}
    />
  );

  return showRemoveModal ? (
    <ConfirmMemberRemovalModal
      onClose={handleCloseRemovalModal}
      llData={removalLandlord}
      refreshFunc={defaultFunc}
    />
  ) : (
    <div
      className="manageMembersModal"
      onClick={() => {
        setIsInputDropdown(false);
        setIsOpenIndex(-1);
      }}
    >
      {/* <p className="text-center">
        {_t("sendANewMemberInviteOrManageYourMembers")}{" "}
      </p> */}

      <h4 className="profile-picture-heading">{_t("inviteLLToWorkspace")}</h4>

      <div className="main-form-group form-group-wrapper formGroupWrapper">
        <div
          className="form-group"
          style={{ flexDirection: "row", justifyContent: "space-between" }}
        >
          {/* <label>{_t("memberEmail")}</label> */}
          <input
            style={{ width: "60%", marginRight: ".2778vw" }}
            type="text"
            placeholder={_t("enterMemberEmail")}
            name="email"
            value={inviteEmail}
            onChange={(e) => setInviteEmail(e.target.value)}
            required
          />
          <div className="position-relative">
            <div
              className="d-flex align-items-center inputMemberTypeDropdown custom-gap-2 justify-content-between cursor-pointer"
              onClick={(e) => {
                e.stopPropagation();
                setIsInputDropdown(!isInputDropdown);
              }}
            >
              <div className="container-heading">
                {/* <img
                  src={`/images/manage-${inviteRole?.toLowerCase() == "owner" ? "owner" : "member"}-icon.svg`}
                  alt=""
                /> */}
                <div>
                  <h3>{_t(`${inviteRole?.toLowerCase()}Member`)}</h3>
                  {/* <p>{_t(`${inviteRole?.toLowerCase()}Description`)}</p> */}
                </div>
              </div>
              <img
                src="/images/down-arrow-grey.svg"
                style={{
                  rotate: isInputDropdown === true ? "180deg" : "0deg",
                }}
              />
            </div>

            {isInputDropdown && (
              <div className="position-absolute memberTypeDropdownList memberTypeWithPara">
                <div className="dropdown-menu-inner d-flex flex-column">
                  {allRoles
                    ?.filter(
                      (role) =>
                        allRoles?.indexOf(role) <=
                        allRoles?.indexOf(user?.current_workspace_role),
                    )
                    ?.filter((role) => role !== "OWNER")
                    .reverse()
                    .map((role) => (
                      <div
                        className="dropdown-open-container position-relative cursor-pointer"
                        onClick={() => changeInviteRole(role)}
                      >
                        <div className="d-flex gap-2">
                          {role?.toLowerCase() == "owner" && (
                            <img src="/images/manage-owner-icon.svg" alt="" />
                          )}
                          <div
                            style={{
                              marginLeft:
                                role?.toLowerCase() !== "owner" ? "24px" : 0,
                            }}
                          >
                            <h3 className="d-flex align-items-center justify-content-between flex-col">
                              {_t(`${role?.toLowerCase()}Member`)}{" "}
                            </h3>
                            <p>{_t(`${role?.toLowerCase()}Description`)}</p>
                          </div>
                        </div>
                        {inviteRole?.toLowerCase() === role?.toLowerCase() && (
                          <img src="/images/check-light-green.svg" />
                        )}
                      </div>
                    ))}
                </div>
              </div>
            )}
          </div>
        </div>

        <div className="inviteButtonWrapper inviteButtonMobileWrapper justify-content-start mt-0">
          <div
            data-tooltip-id="button-action-tooltip"
            style={{ display: "inline-block" }}
          >
            <button
              type="button"
              onClick={handleSendInvite}
              className="btnNext basicInfoButton greenHover"
              disabled={!haveValue(inviteEmail) || isSendingInvite}
            >
              {isSendingInvite ? `${_t("sending")}...` : _t("sendInvite")}
            </button>
            {!haveValue(inviteEmail) && <ButtonActionTooltip />}
          </div>
        </div>
      </div>

      {localLoader ? (
        <Loader />
      ) : (
        <>
          <h4 className="memberText">{_t("members")}</h4>

          <div className="membersList">
            {workspaceMembers?.map((val, index) =>
              val?.status === "invited" ? (
                ""
              ) : (
                <div className="d-flex align-items-center justify-content-between">
                  <div className="d-flex align-items-center flex-wrap memberItemWrapper">
                    <div className="d-flex align-items-center justify-content-center memberItem custom-gap-2">
                      <div className="earner-thumbnail-wrapper">
                        <img src={UserIcon} alt="User Icon" />
                      </div>
                      <h6>
                        {val?.status === "invited"
                          ? val?.email
                          : haveValue(val?.landlordId)
                            ? `${val?.landlordId?.fname_companyName} ${val?.landlordId?.lname}`
                            : val?.email}
                      </h6>
                    </div>
                    {(() => {
                      let emailVal = getInstitutionalDomainName(
                        val?.landlordId?.email,
                      );
                      if (haveValue(emailVal)) {
                        return (
                          <span className="email-institutional-text">
                            {emailVal}
                          </span>
                        );
                      }
                    })()}
                  </div>
                  <div className="memberTypeDropdown position-relative">
                    <div
                      className={`d-flex align-items-center memberTypeDropdownHeader custom-gap-2 ${(!isDefaultWorkspace(user) || index !== 0) && !isOwnerOfWorkspace(user, val) ? "cursor-pointer" : ""}`}
                      onClick={(e) => {
                        e.stopPropagation();
                        if (index === 0 && isDefaultWorkspace(user)) {
                          return;
                        }
                        if(isOwnerOfWorkspace(user, val)){
                          return
                        }
                        setIsOpenIndex(isOpenIndex === index ? -1 : index);
                      }}
                    >
                      <h3>{_t(`${val?.role?.toLowerCase()}Member`)}</h3>
                      {((!isDefaultWorkspace(user) || index !== 0) && !isOwnerOfWorkspace(user, val)) &&
                        allRoles?.indexOf(val?.role) <=
                          allRoles?.indexOf(user?.current_workspace_role) && (
                          <img
                            src="/images/down-arrow-grey.svg"
                            style={{
                              rotate: isOpenIndex === index ? "180deg" : "0deg",
                            }}
                          />
                        )}
                    </div>

                    {isOpenIndex === index &&
                      allRoles?.indexOf(val?.role) <=
                        allRoles?.indexOf(user?.current_workspace_role) && (
                        <div className="position-absolute memberTypeDropdownList memberListDropdown">
                          <div className="dropdown-menu-inner dropdownInner d-flex flex-column">
                            {allRoles
                              ?.filter(
                                (role, index) =>
                                  allRoles?.indexOf(role) <=
                                    allRoles?.indexOf(
                                      user?.current_workspace_role,
                                    ) && role != "GUEST",
                              )?.filter((role)=>role !=="OWNER")
                              ?.reverse()
                              ?.map((role) => (
                                <h3
                                  className="d-flex align-items-center justify-content-between cursor-pointer"
                                  onClick={() => {
                                    changeMemberRole(
                                      { target: { value: role } },
                                      val,
                                      index,
                                    );
                                  }}
                                >
                                  {_t(`${role?.toLowerCase()}Member`)}{" "}
                                  {val?.role === role && (
                                    <CheckmarkIcon val={val} />
                                  )}
                                </h3>
                              ))}

                            {/* REMOVE */}
                            {val?.landlordId?._id?.toString() !==
                              user?.current_workspace?.created_by && (
                              <h3
                                className="d-flex align-items-center last-h3 justify-content-between cursor-pointer text-danger"
                                onClick={() => {
                                  handleRemoveMember(val);
                                }}
                              >
                                {_t("remove")}
                              </h3>
                            )}
                          </div>
                        </div>
                      )}
                  </div>
                </div>
              ),
            )}
          </div>
        </>
      )}
      {workspaceMembers.some((v) => v.status === "invited") && (
        <h4 className="memberText">{_t("pendingInvites")}</h4>
      )}
      <div className="membersList">
        {workspaceMembers?.map((val) =>
          val?.status === "invited" ? (
            <div className="d-flex align-items-center justify-content-between">
              <div className="d-flex align-items-center justify-content-center memberItem custom-gap-2">
                <div className="earner-thumbnail-wrapper">
                  <img src={UserIcon} alt="User Icon" />
                </div>
                <h6 className="email-word-break-mobile">
                  {val?.status === "invited"
                    ? val?.email
                    : `${val?.landlordId?.fname_companyName} ${val?.landlordId?.lname}`}
                </h6>
              </div>
              <div className="d-flex align-items-center form-group-wrapper justify-content-end selectWrapper custom-gap-2">
                <p className="inviteSentText">{_t("inviteSent")}</p>
              </div>
            </div>
          ) : (
            ""
          ),
        )}
      </div>
    </div>
  );
};

export default ManageMembers;
